import callAPI from 'api'

import {
  CreateLeadContactPayload,
  DeleteContactInfoPayload,
  DeleteLeadContactPayload,
  GetLeadContactsResponse,
  UpdateLeadContactPayload,
  UpdateLeadContactStatusPayload,
} from './types/lead-contact'

export const getLeadContactApi = async (payload: { lead_id: string }) =>
  callAPI<GetLeadContactsResponse[], { lead_id: string }>('crm_get_lead_contacts', [payload], {
    requireAuthorization: true,
  })

export const createLeadContact = async (payload: CreateLeadContactPayload) =>
  await callAPI<{ success: boolean; contact_person_id: string }, CreateLeadContactPayload>(
    'crm_create_lead_contact',
    [payload],
    {
      requireAuthorization: true,
      reloadOnReauth: false,
    },
  )

export const deleteLeadContact = async (payload: DeleteLeadContactPayload) =>
  await callAPI<{ success: boolean }, DeleteLeadContactPayload>('crm_delete_lead_contact', [payload], {
    requireAuthorization: true,
    reloadOnReauth: false,
  })

export const updateLeadContact = async (payload: UpdateLeadContactPayload) =>
  await callAPI<{ success: boolean; contact_person_id: string }, UpdateLeadContactPayload>(
    'crm_update_lead_contact',
    [payload],
    {
      requireAuthorization: true,
      reloadOnReauth: false,
    },
  )

export const updateLeadContactStatus = async (payload: UpdateLeadContactStatusPayload) =>
  await callAPI<{ success: boolean }, UpdateLeadContactStatusPayload>('crm_set_lead_contact_status', [payload], {
    requireAuthorization: true,
  })

export const deleteContactInfoApi = async (payload: DeleteContactInfoPayload) =>
  await callAPI<{ success: boolean }, DeleteContactInfoPayload>('crm_delete_lead_contact_info', [payload], {
    requireAuthorization: true,
  })
